import { Button, Input } from "@shared/ui";
import { Error } from "@shared/ui/icons";
import { ArrowRight, Instagram, Youtube } from "lucide-react";
import styles from "./form.module.scss";

interface SingleCreatorFormProps {
  platform: "instagram" | "youtube" | "tiktok";
  handle: string;
  status: "idle" | "validating" | "error";
  errorMsg: string;
  isAdding: boolean;
  onPlatformChange: (platform: "instagram" | "youtube" | "tiktok") => void;
  onHandleChange: (value: string) => void;
  onSubmit: () => void;
}

export function SingleCreatorForm({
  platform,
  handle,
  status,
  errorMsg,
  isAdding,
  onPlatformChange,
  onHandleChange,
  onSubmit,
}: SingleCreatorFormProps) {
  const isBusy = status === "validating" || isAdding;

  return (
    <div className={styles.content}>
      <div className={styles.platformGrid}>
        <button
          type="button"
          disabled={isBusy}
          onClick={() => onPlatformChange("instagram")}
          className={`${styles.platformButton} ${
            platform === "instagram" ? styles.platformButtonInstagram : ""
          }`}
        >
          <Instagram size={20} />
          <span>Instagram</span>
        </button>
        <button
          type="button"
          disabled={isBusy}
          onClick={() => onPlatformChange("youtube")}
          className={`${styles.platformButton} ${
            platform === "youtube" ? styles.platformButtonYoutube : ""
          }`}
        >
          <Youtube size={20} />
          <span>YouTube</span>
        </button>
        <button
          type="button"
          disabled={isBusy}
          className={`${styles.platformButton} ${styles.disabled} ${
            platform === "tiktok" ? styles.platformButtonTiktok : ""
          }`}
        >
          <div className={styles.tiktokIcon}>Tk</div>
          <span>TikTok</span>
        </button>
      </div>

      <div className={styles.inputGroup}>
        <label className={styles.label}>Username / Handle</label>
        <div className={styles.inputWrapper}>
          <span className={styles.atSymbol}>@</span>
          <Input
            type="text"
            value={handle}
            disabled={isBusy}
            onChange={(e) => onHandleChange(e.target.value.replace("@", ""))}
            onPressEnter={onSubmit}
            placeholder="username"
            className={`${styles.input} ${
              status === "error" ? styles.inputError : ""
            }`}
            autoFocus
          />
        </div>
        {status === "error" && (
          <div className={styles.errorMessage}>
            <Error size={12} />
            <span>{errorMsg}</span>
          </div>
        )}
      </div>

      <Button
        onClick={onSubmit}
        disabled={isBusy || !handle}
        type="primary"
        loading={isBusy}
        className={styles.addButton}
        icon={!isBusy ? <ArrowRight size={16} /> : undefined}
        iconPosition="end"
      >
        {isBusy ? "Validating..." : "Add to Brief"}
      </Button>
    </div>
  );
}
